import Vue from 'vue'

const currency = (amountDetails) => {
  const currencies = {
    'EUR': '\u20AC'
  }

  const symbol = currencies[amountDetails.currency]
  const amount = amountDetails.amount.toFixed(2).replace('.', ',')

  return symbol + ' ' + amount
}

Vue.filter('currency', currency)

export default currency



// WEBPACK FOOTER //
// ./src/filters/currency.js